import { HttpMethod } from '../methods';
import { UrlConstant } from '../../utils/interfaces';

export const GET_TRANSLATIONS: UrlConstant = { path: '/qa/list', method: HttpMethod.GET };
